// extracted by mini-css-extract-plugin
export default {"banner":"Home_banner__xYdSW"};